import { ChatToolContext, type ChatToolState } from '#components/chat/contexts/ChatToolContext';

export function ChatToolProvider({ children, tools }: React.PropsWithChildren<ChatToolState>) {
  return <ChatToolContext.Provider value={{ tools }}>{children}</ChatToolContext.Provider>;
}
